'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { trackPageView } from '../core';

import type { PageViewData } from '../types';
import type { FC} from 'react';

type Props = {
  data?: Partial<PageViewData>;
};

export const TrackPageView: FC<Props> = ({ data }) => {
  const pathname = usePathname();
  const trackedPathname = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (trackedPathname.current === pathname) {
      return;
    }

    trackedPathname.current = pathname ?? undefined;
    trackPageView(data);
  }, [pathname]);

  return null;
};
